import { cn } from '@workspace/ui/lib/utils';
import React from 'react';

import styles from './Typography.module.scss';

type PolymorphicTextProps<T extends React.ElementType> =
  React.ComponentPropsWithRef<T> & {
    as?: T;
  };

export const Header50Medium = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h4', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header50Medium,
        className,
      )}
    />
  );
});
Header50Medium.displayName = 'Header50Medium';

export const Header100Medium = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h3', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header100Medium,
        className,
      )}
    />
  );
});
Header100Medium.displayName = 'Header100Medium';

export const Header150Medium = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h2', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header150Medium,
        className,
      )}
    />
  );
});
Header150Medium.displayName = 'Header150Medium';

export const Header150Semibold = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h2', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header150Semibold,
        className,
      )}
    />
  );
});
Header150Semibold.displayName = 'Header150Semibold';

export const Header200Medium = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h1', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header200Medium,
        className,
      )}
    />
  );
});
Header200Medium.displayName = 'Header200Medium';

export const Header300Medium = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h1', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header300Medium,
        className,
      )}
    />
  );
});
Header300Medium.displayName = 'Header300Medium';

export const Text200Regular = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text200Regular, className)}
    />
  );
});
Text200Regular.displayName = 'Text200Regular';

/* Header — остальные варианты по citydrinks */
export const Header500Regular = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h1', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header500Regular,
        className,
      )}
    />
  );
});
Header500Regular.displayName = 'Header500Regular';

export const Header400Semibold = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h1', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header400Semibold,
        className,
      )}
    />
  );
});
Header400Semibold.displayName = 'Header400Semibold';

export const Header400Medium = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h1', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header400Medium,
        className,
      )}
    />
  );
});
Header400Medium.displayName = 'Header400Medium';

export const Header400Light = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h1', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header400Light,
        className,
      )}
    />
  );
});
Header400Light.displayName = 'Header400Light';

export const Header300Regular = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h1', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header300Regular,
        className,
      )}
    />
  );
});
Header300Regular.displayName = 'Header300Regular';

export const Header300Light = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h1', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header300Light,
        className,
      )}
    />
  );
});
Header300Light.displayName = 'Header300Light';

export const Header200Semibold = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h2', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header200Semibold,
        className,
      )}
    />
  );
});
Header200Semibold.displayName = 'Header200Semibold';

export const Header300Semibold = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h2', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header300Semibold,
        className,
      )}
    />
  );
});
Header300Semibold.displayName = 'Header300Semibold';

export const Header200Light = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h2', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header200Light,
        className,
      )}
    />
  );
});
Header200Light.displayName = 'Header200Light';

export const Header150Light = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h2', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header150Light,
        className,
      )}
    />
  );
});
Header150Light.displayName = 'Header150Light';

export const Header100Semibold = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h3', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header100Semibold,
        className,
      )}
    />
  );
});
Header100Semibold.displayName = 'Header100Semibold';

export const Header50Semibold = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h4', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeading,
        styles.header50Semibold,
        className,
      )}
    />
  );
});
Header50Semibold.displayName = 'Header50Semibold';

export const AltHeader100Semibold = React.forwardRef<
  HTMLHeadingElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'h3', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerHeadingAlt,
        styles.altHeader100Semibold,
        className,
      )}
    />
  );
});
AltHeader100Semibold.displayName = 'AltHeader100Semibold';

/* Text — body по citydrinks */
export const Text600Regular = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text600Regular, className)}
    />
  );
});
Text600Regular.displayName = 'Text600Regular';

export const Text600RegularHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text600RegularHigh,
        className,
      )}
    />
  );
});
Text600RegularHigh.displayName = 'Text600RegularHigh';

export const Text600Medium = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text600Medium, className)}
    />
  );
});
Text600Medium.displayName = 'Text600Medium';

export const Text600MediumHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text600MediumHigh,
        className,
      )}
    />
  );
});
Text600MediumHigh.displayName = 'Text600MediumHigh';

export const Text600Semibold = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text600Semibold, className)}
    />
  );
});
Text600Semibold.displayName = 'Text600Semibold';

export const Text600SemiboldHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text600SemiboldHigh,
        className,
      )}
    />
  );
});
Text600SemiboldHigh.displayName = 'Text600SemiboldHigh';

export const Text500Regular = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text500Regular, className)}
    />
  );
});
Text500Regular.displayName = 'Text500Regular';

export const Text500Semibold = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text500Semibold, className)}
    />
  );
});
Text500Semibold.displayName = 'Text500Semibold';

export const Text500RegularHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text500RegularHigh,
        className,
      )}
    />
  );
});
Text500RegularHigh.displayName = 'Text500RegularHigh';

export const Text500Medium = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text500Medium, className)}
    />
  );
});
Text500Medium.displayName = 'Text500Medium';

export const Text500MediumHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text500MediumHigh,
        className,
      )}
    />
  );
});
Text500MediumHigh.displayName = 'Text500MediumHigh';

export const Text500SemiboldHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text500SemiboldHigh,
        className,
      )}
    />
  );
});
Text500SemiboldHigh.displayName = 'Text500SemiboldHigh';

export const Text400Regular = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text400Regular, className)}
    />
  );
});
Text400Regular.displayName = 'Text400Regular';

export const Text400Medium = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text400Medium, className)}
    />
  );
});
Text400Medium.displayName = 'Text400Medium';

export const Text400Semibold = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text400Semibold, className)}
    />
  );
});
Text400Semibold.displayName = 'Text400Semibold';

export const Text400SemiboldHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text400SemiboldHigh,
        className,
      )}
    />
  );
});
Text400SemiboldHigh.displayName = 'Text400SemiboldHigh';

export const Text400RegularHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text400RegularHigh,
        className,
      )}
    />
  );
});
Text400RegularHigh.displayName = 'Text400RegularHigh';

export const Text400MediumHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text400MediumHigh,
        className,
      )}
    />
  );
});
Text400MediumHigh.displayName = 'Text400MediumHigh';

export const Text300Medium = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text300Medium, className)}
    />
  );
});
Text300Medium.displayName = 'Text300Medium';

export const Text300MediumHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text300MediumHigh,
        className,
      )}
    />
  );
});
Text300MediumHigh.displayName = 'Text300MediumHigh';

export const Text300Regular = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text300Regular, className)}
    />
  );
});
Text300Regular.displayName = 'Text300Regular';

export const Text300RegularHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text300RegularHigh,
        className,
      )}
    />
  );
});
Text300RegularHigh.displayName = 'Text300RegularHigh';

export const Text300Semibold = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text300Semibold, className)}
    />
  );
});
Text300Semibold.displayName = 'Text300Semibold';

export const Text300SemiboldHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text300SemiboldHigh,
        className,
      )}
    />
  );
});
Text300SemiboldHigh.displayName = 'Text300SemiboldHigh';

export const Text200RegularHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text200RegularHigh,
        className,
      )}
    />
  );
});
Text200RegularHigh.displayName = 'Text200RegularHigh';

export const Text200Medium = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text200Medium, className)}
    />
  );
});
Text200Medium.displayName = 'Text200Medium';

export const Text200MediumHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text200MediumHigh,
        className,
      )}
    />
  );
});
Text200MediumHigh.displayName = 'Text200MediumHigh';

export const Text200Semibold = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text200Semibold, className)}
    />
  );
});
Text200Semibold.displayName = 'Text200Semibold';

export const Text200SemiboldHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text200SemiboldHigh,
        className,
      )}
    />
  );
});
Text200SemiboldHigh.displayName = 'Text200SemiboldHigh';

export const Text100Regular = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text100Regular, className)}
    />
  );
});
Text100Regular.displayName = 'Text100Regular';

export const Text100RegularHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text100RegularHigh,
        className,
      )}
    />
  );
});
Text100RegularHigh.displayName = 'Text100RegularHigh';

export const Text100Medium = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text100Medium, className)}
    />
  );
});
Text100Medium.displayName = 'Text100Medium';

export const Text100MediumHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text100MediumHigh,
        className,
      )}
    />
  );
});
Text100MediumHigh.displayName = 'Text100MediumHigh';

export const Text100Semibold = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text100Semibold, className)}
    />
  );
});
Text100Semibold.displayName = 'Text100Semibold';

export const Text100SemiboldHigh = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(
        styles.fontCustomerText,
        styles.text100SemiboldHigh,
        className,
      )}
    />
  );
});
Text100SemiboldHigh.displayName = 'Text100SemiboldHigh';

export const Text50Regular = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text50Regular, className)}
    />
  );
});
Text50Regular.displayName = 'Text50Regular';

export const Text50Medium = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text50Medium, className)}
    />
  );
});
Text50Medium.displayName = 'Text50Medium';

export const Text50Semibold = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.text50Semibold, className)}
    />
  );
});
Text50Semibold.displayName = 'Text50Semibold';

export const TextBody15m = React.forwardRef<
  HTMLParagraphElement,
  PolymorphicTextProps<React.ElementType>
>(({ as = 'p', className, ...props }, ref) => {
  const Component = as;

  return (
    <Component
      {...props}
      ref={ref}
      className={cn(styles.fontCustomerText, styles.textBody15m, className)}
    />
  );
});
TextBody15m.displayName = 'TextBody15m';
